<template>
<div>
    <div v-for="(exam,i) in examData" :key="'exam-data-'+i" class="col-sm-8">
    
      <h3>Pregled reševanja  {{exam.class.name}} za Izpit {{exam.exam.title}}, ki se začne ob {{humanize(exam.startsAt) | formatDate}}</h3>
      <div v-for="eve in exam.events" :key="eve.id">
        <!-- {{eve}} -->
        
        {{eve.user.firstName}} {{eve.user.lastName}} {{eve.user.studentId}} je oddal odgovor na vprašanje {{eve.correct}} ob {{eve.createdAt | formatDate}} 
      </div>
      

    </div>
    <div class="col-sm-4">
      <h3>Prisotnih študentov: {{usersSolving.length}}</h3>
      <div v-for="(user,i) in usersSolving" :key="'user-'+user.id">
        {{user.firstName}} {{user.lastName}} {{user.lastName}} {{user.studentId}}
      </div>
    </div>
    

</div>
</template>

<script>
import Rest from './../../services/rest'
import router from './../../router/router'
import moment from 'moment'
export default {
  data () {
    return {
      examData: null,
      timer: null,
      usersSolving: []
    }
  },
  methods: {
    async getData () {
      console.log(router)
      console.log('leh', this.$route.params.examId)
      return Rest.request('GET', `/exams/${this.$route.params.examId}/showDetails`).then((data) => {
        this.examData = data.classExams
        this.usersSolving = data.usersSolving
      }).catch(function (err) {
        console.log(err)
      })
    },
    humanize (datum) {
      return moment(datum).subtract('hours', 1).toDate()
    }
  },
  destroyed () {
    clearInterval(this.timer)
  },
  mounted () {
    this.timer = setInterval(() => {
      this.getData()
    }, 500)
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// SolvingExam.vue?189d43a6